import styled from 'styled-components'
import Wrapper from 'common/wrapper'
import { Typography } from 'common/typography'
import { FaChevronDown } from 'react-icons/fa'
import faqs from './faqs'

const ProjectsFaqStyled = styled.section`
  h2 {
    text-align: center;
  }
  summary {
    display: flex;
    align-items: center;
    margin: 0 auto;
    justify-content: space-between;
    cursor: pointer;
    user-select: none;
    list-style-image: unset;
    list-style: none;
    h4 {
      flex: 1;
    }
    svg {
      flex-shrink: 0;
      margin-left: .5rem;
    }
  }
  summary::marker, summary::-webkit-details-marker {
    display: none;
    color: transparent;
  }
  details[open] {
    summary svg {
      transform: rotate(180deg);
    }
  }
  p {
    font: var(--p2Regular);
    margin-top: 8px;
    color: var(--white);
  }
  a {
    color: var(--turquoise);
    font-weight: 700;
    text-decoration: underline;
  }
  .faq {
    margin: 16px 0;
    border-radius: 8px;
    padding: 16px;
    background: var(--neutral100);
    ul {
      margin-top: 16px;
      padding-left: 16px;
      list-style: outside;
      li {
        margin: 8px 0;
      }
    }
  }
  .faq-email:hover {
    text-decoration: underline;
  }
  .faq-post {
    color: var(--secondary);
    transition: 0.3s ease-in color;
    text-decoration: underline;
    font-weight: 600;
    &:hover {
      color: var(--secondaryHover);
    }
    &:hover {
      color: var(--secondaryActive);
    }
  }
  @media(min-width: 768px) {
    .faqs {
      display: grid;
      grid-template-columns: 1fr 1fr;
      column-gap: 24px;
      row-gap: 24px;
    }
    .faq {
      margin: 16px 0;
      padding: 24px;
    }
    p {
      font: var(--regular);
      margin-top: 16px;
    }
  }
`

function ProjectsFaq() {
  return (
    <ProjectsFaqStyled aria-label="Preguntas Frecuentes">
      <Wrapper maxWidth="1200">
        <Typography small="headline6" large="headline4" as="h2" color="var(--baseNeutral)">
          Preguntas frecuentes
        </Typography>
        <ul className="faqs">
          <div className="faqs-left">
            {faqs.map(({ title, content }, idx) => idx % 2 !== 0 && (
              <li className="faq" key={title}>
                <details>
                  <summary>
                    <Typography as="h4" color="var(--baseNeutral)" small="regular" large="headline6">{title}</Typography>
                    <FaChevronDown color="inherit" size="14px" />
                  </summary>
                  {content}
                </details>
              </li>
            ))}
          </div>
          <div className="faqs-right">
            {faqs.map(({ title, content }, idx) => idx % 2 === 0 && (
              <li className="faq" key={title}>
                <details>
                  <summary>
                    <Typography as="h4" color="var(--baseNeutral)" small="regular" large="headline6">{title}</Typography>
                    <FaChevronDown color="inherit" size="14px" />
                  </summary>
                  {content}
                </details>
              </li>
            ))}
          </div>
        </ul>
      </Wrapper>
    </ProjectsFaqStyled>
  )
}

export default ProjectsFaq
